// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Detalhe eSocial (TXM-336) — layout alinhado ao Detalhe Conciliacao SPED.
 */

.detalheEsocial_styles_pageWrap__IoePv {
  padding: 24px;
}

.detalheEsocial_styles_container__mrVzS {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.detalheEsocial_styles_linkVoltar__R0mjr {
  display: inline-block;
  margin-bottom: 12px;
  font-size: 14px;
  color: #1e4a7a;
  font-weight: 600;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
}

.detalheEsocial_styles_linkVoltar__R0mjr:hover {
  text-decoration: underline;
}

.detalheEsocial_styles_pageHeader__evHr- {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: nowrap;
  margin-bottom: 25px;
}

.detalheEsocial_styles_headerMain__hO6xL {
  flex: 1 1 auto;
  min-width: 0;
}

.detalheEsocial_styles_pageTitle__lDPbL {
  font-size: 26px;
  color: #0d2847;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
}

.detalheEsocial_styles_pageSubtitle__Czle2 {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
  font-family: ui-monospace, monospace;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.detalheEsocial_styles_contaRef__DYgST {
  display: inline-block;
  margin-top: 4px;
  color: #1e4a7a;
  font-weight: 600;
}

.detalheEsocial_styles_badgeTipo__L8hGe {
  display: inline-block;
  margin-top: 10px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  background: #e8f0f8;
  color: #1e4a7a;
}

.detalheEsocial_styles_badgeRubricas__jSZ8S {
  display: inline-block;
  margin-top: 10px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background: #e8f5e9;
  color: #2e7d32;
}

.detalheEsocial_styles_badge20s__U92tS {
  display: inline-block;
  margin-top: 10px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  background: #f3e5f5;
  color: #6a1b9a;
}

.detalheEsocial_styles_headerActions__XHsf3 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  flex: 0 0 auto;
  justify-content: flex-end;
  max-width: min(520px, 48%);
}

@media (max-width: 900px) {
  .detalheEsocial_styles_pageHeader__evHr- {
    flex-wrap: wrap;
  }

  .detalheEsocial_styles_headerActions__XHsf3 {
    max-width: 100%;
    width: 100%;
    justify-content: flex-start;
  }
}

.detalheEsocial_styles_btnHeader__wk-j5 {
  padding: 10px 16px;
  border-radius: 6px;
  border: 1px solid #1e4a7a;
  background: #fff;
  color: #1e4a7a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.detalheEsocial_styles_btnHeaderPrimary__46Bjd {
  background: #1e4a7a;
  color: #fff;
  border-color: #1e4a7a;
}

.detalheEsocial_styles_btnHeaderActive__7Omfn {
  background: #e8f0f8;
  border-color: #1e4a7a;
}

.detalheEsocial_styles_btnHeader__wk-j5:hover:not(:disabled) {
  filter: brightness(1.05);
}

.detalheEsocial_styles_btnHeader__wk-j5:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.detalheEsocial_styles_dashWrap__tHWaH {
  margin-bottom: 25px;
}

.detalheEsocial_styles_dashGrid__-4wfm {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 18px;
}

@media (max-width: 1100px) {
  .detalheEsocial_styles_dashGrid__-4wfm {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .detalheEsocial_styles_dashGrid__-4wfm {
    grid-template-columns: 1fr;
  }
}

.detalheEsocial_styles_dashCard__\\+sf0t {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  border-radius: 12px;
  padding: 16px 14px;
  border-left: 4px solid #1e4a7a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  min-width: 0;
}

.detalheEsocial_styles_dashCardVazio__UXYAu {
  grid-column: 1 / -1;
  border-left-color: #888;
  background: linear-gradient(135deg, #f5f5f5 0%, #fff 100%);
}

.detalheEsocial_styles_dashCardWide__NKoX- {
  grid-column: 1 / -1;
  max-width: 420px;
}

.detalheEsocial_styles_dashAlertaTexto__VwuLN {
  margin: 10px 0 0;
  font-size: 13px;
  color: #555;
  line-height: 1.5;
}

.detalheEsocial_styles_dashLbl__5Sq1b {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.detalheEsocial_styles_dashHint__Qtp5N {
  font-size: 11px;
  color: #888;
  margin-top: 4px;
  font-weight: 500;
}

.detalheEsocial_styles_dashVal__vOSOE {
  margin-top: 8px;
  font-weight: 700;
  color: #0d2847;
  font-family: ui-monospace, monospace;
  font-size: clamp(12px, 0.2rem + 1.15vw, 15px);
}

.detalheEsocial_styles_dashStack__1CQeC {
  display: flex;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 12px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.detalheEsocial_styles_dashStack__1CQeC span {
  display: block;
  min-width: 0;
}

.detalheEsocial_styles_dashLegend__PQR-4 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-top: 10px;
  font-size: 11px;
  color: #555;
}

.detalheEsocial_styles_dashLegend__PQR-4 strong {
  color: #0d2847;
  font-weight: 700;
}

.detalheEsocial_styles_dashLegendPct__bfeot {
  color: #888;
}

.detalheEsocial_styles_yearDot__i6WGn {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 5px;
  vertical-align: middle;
}

/* Seta de expandir/recolher a legenda dos cards de dashboard quando passa de 3 linhas. */
.detalheEsocial_styles_dashLegendToggle__V6v6J {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 2px 0;
  border: none;
  background: none;
  color: #1f5fa8;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.detalheEsocial_styles_dashLegendToggle__V6v6J:hover {
  text-decoration: underline;
}

.detalheEsocial_styles_dashLegendToggleIcon__q0bOa {
  display: inline-block;
  font-size: 10px;
  transition: transform 0.15s ease;
}

.detalheEsocial_styles_dashLegendToggleIconOpen__f8YWD {
  transform: rotate(180deg);
}

.detalheEsocial_styles_sectionListHeader__wq6ld {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.detalheEsocial_styles_sectionTitle__JQIuW {
  font-size: 18px;
  font-weight: 600;
  color: #0d2847;
  margin: 0;
}

.detalheEsocial_styles_toolbar__1cl28 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-left: auto;
}

.detalheEsocial_styles_toolbarHint__ErtiT {
  font-size: 13px;
  color: #666;
}

.detalheEsocial_styles_btnExportar__lwo1a {
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid #1e4a7a;
  background: #fff;
  color: #1e4a7a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.detalheEsocial_styles_btnExportar__lwo1a:hover:not(:disabled) {
  background: #f0f4fa;
}

.detalheEsocial_styles_btnExportar__lwo1a:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.detalheEsocial_styles_exportMenuWrap__pGNVy {
  position: relative;
}

.detalheEsocial_styles_exportMenu__9B3oP {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 4px;
  z-index: 20;
  min-width: 200px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 4px 0;
}

.detalheEsocial_styles_exportMenuItem__TM6Ei {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  border: none;
  background: transparent;
  font: inherit;
  font-size: 13px;
  color: #0d2847;
  cursor: pointer;
}

.detalheEsocial_styles_exportMenuItem__TM6Ei:hover {
  background: #f0f2f5;
}

.detalheEsocial_styles_filtersSection__wi2iZ {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px 20px 20px;
  margin-bottom: 25px;
}

.detalheEsocial_styles_filtersSectionCollapsed__51TuN {
  padding-bottom: 16px;
}

.detalheEsocial_styles_filtersHeader__iqXDm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}

.detalheEsocial_styles_filtersHeaderExpanded__CzLfg {
  margin-bottom: 12px;
}

.detalheEsocial_styles_filtersTitle__A\\+4vZ {
  font-size: 13px;
  font-weight: 600;
  color: #0d2847;
  margin-bottom: 0;
}

.detalheEsocial_styles_filtersToggleIcon__noJm\\+ {
  font-size: 11px;
  color: #1e4a7a;
  transition: transform 0.2s ease;
  transform: rotate(-90deg);
  line-height: 1;
}

.detalheEsocial_styles_filtersToggleIconOpen__rr4Bb {
  transform: rotate(0deg);
}

.detalheEsocial_styles_filtersBody__OZo2I {
  padding-top: 4px;
}

.detalheEsocial_styles_filtersRow__hWHdf {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  align-items: flex-end;
}

.detalheEsocial_styles_filterGroup__sqnZi {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.detalheEsocial_styles_filterLabel__t9KPr {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.detalheEsocial_styles_filterInput__tUVrS,
.detalheEsocial_styles_filterSelect__WpI5F {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  min-width: 160px;
  font-family: inherit;
  background: #fff;
}

.detalheEsocial_styles_filterInput__tUVrS[type="month"] {
  min-height: 38px;
}

.detalheEsocial_styles_filterTwin__YBcY3 {
  display: flex;
  align-items: center;
  gap: 10px;
}

.detalheEsocial_styles_filterTwinSep__A-Z6j {
  font-size: 12px;
  color: #888;
}

.detalheEsocial_styles_btnLimpar__27pyD {
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #fff;
  color: #555;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.detalheEsocial_styles_tableWrap__jkTBo {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 16px;
  scrollbar-width: auto; /* Firefox — evita barra fina do global */
}

.detalheEsocial_styles_tableWrap__jkTBo::-webkit-scrollbar,
.detalheEsocial_styles_lancamentosTableWrap__YzpdS::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

.detalheEsocial_styles_tableWrap__jkTBo::-webkit-scrollbar-track,
.detalheEsocial_styles_lancamentosTableWrap__YzpdS::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.detalheEsocial_styles_tableWrap__jkTBo::-webkit-scrollbar-thumb,
.detalheEsocial_styles_lancamentosTableWrap__YzpdS::-webkit-scrollbar-thumb {
  background: rgba(24, 49, 110, 0.75);
  border-radius: 6px;
}

.detalheEsocial_styles_tableWrap__jkTBo::-webkit-scrollbar-thumb:hover,
.detalheEsocial_styles_lancamentosTableWrap__YzpdS::-webkit-scrollbar-thumb:hover {
  background: rgba(24, 49, 110, 0.95);
}

.detalheEsocial_styles_table__WlcTn {
  width: 100%;
  min-width: 2480px;
  border-collapse: collapse;
  table-layout: auto;
}

.detalheEsocial_styles_table__WlcTn thead {
  background: #f8f9fa;
}

.detalheEsocial_styles_table__WlcTn th {
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  color: #0d2847;
  border-bottom: 2px solid #e0e0e0;
  font-size: 13px;
  white-space: nowrap;
}

.detalheEsocial_styles_table__WlcTn th.detalheEsocial_styles_num__1FRM3,
.detalheEsocial_styles_table__WlcTn td.detalheEsocial_styles_num__1FRM3,
.detalheEsocial_styles_num__1FRM3 {
  text-align: right;
}

/* Colunas monetárias: largura acompanha header/valor sem quebrar linha */
.detalheEsocial_styles_colValor__gGg\\+9 {
  white-space: nowrap;
  min-width: 158px;
  width: 1%;
  padding-left: 14px;
  padding-right: 16px;
  box-sizing: border-box;
}

.detalheEsocial_styles_table__WlcTn th.detalheEsocial_styles_colValor__gGg\\+9,
.detalheEsocial_styles_table__WlcTn td.detalheEsocial_styles_colValor__gGg\\+9 {
  white-space: nowrap;
  min-width: 158px;
  width: 1%;
  padding-left: 14px;
  padding-right: 16px;
}

.detalheEsocial_styles_sortable__9am1O {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding-right: 22px;
  position: relative;
}

.detalheEsocial_styles_table__WlcTn th.detalheEsocial_styles_sortable__9am1O:hover {
  background: #eef2f7;
}

.detalheEsocial_styles_sortedAsc__ahxWE::after,
.detalheEsocial_styles_sortedDesc__h-OHL::after {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: #1e4a7a;
}

.detalheEsocial_styles_sortedAsc__ahxWE::after {
  content: "▲";
}

.detalheEsocial_styles_sortedDesc__h-OHL::after {
  content: "▼";
}

.detalheEsocial_styles_table__WlcTn td {
  padding: 15px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #555;
  vertical-align: middle;
}

.detalheEsocial_styles_table__WlcTn td.detalheEsocial_styles_num__1FRM3 {
  font-family: ui-monospace, monospace;
  white-space: nowrap;
}

.detalheEsocial_styles_table__WlcTn tbody tr:hover {
  background: #f8f9fa;
}

.detalheEsocial_styles_rowCompStart__JP42o td {
  border-top: 2px solid #e0e8ef;
}

.detalheEsocial_styles_rowCompStart__JP42o:first-child td {
  border-top: none;
}

/* TXM-480 — destaque de linhas cuja rubrica tem base legal atribuída (fazem parte do
   projeto de recuperação). Compartilhado pelas tabelas de Detalhe, Rúbricas e
   Lançamentos. */
.detalheEsocial_styles_linhaComBaseLegal__dg0cv td {
  background: #eef4ff;
}

.detalheEsocial_styles_table__WlcTn tbody tr.detalheEsocial_styles_linhaComBaseLegal__dg0cv:hover td {
  background: #e2ecff;
}

.detalheEsocial_styles_badgeBaseLegal__KByhD {
  display: inline-block;
  margin-left: 8px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: #dbeafe;
  color: #1e3a8a;
  white-space: nowrap;
}

.detalheEsocial_styles_compCell__4X2qS {
  font-weight: 600;
  color: #0d2847;
  white-space: nowrap;
}

.detalheEsocial_styles_rubricaCod__ALqaF {
  font-family: ui-monospace, monospace;
  font-size: 13px;
  white-space: nowrap;
}

.detalheEsocial_styles_rubricaDesc__ishja {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detalheEsocial_styles_rubricasTable__3YyAS {
  min-width: 1580px;
}

.detalheEsocial_styles_rubricasTable__3YyAS th {
  white-space: nowrap;
  vertical-align: bottom;
}

.detalheEsocial_styles_rubricasTable__3YyAS td {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detalheEsocial_styles_rubricasTable__3YyAS td.detalheEsocial_styles_cellFlag__3rYnR {
  max-width: none;
  overflow: visible;
  white-space: nowrap;
  padding: 6px 10px;
  text-align: left;
}

.detalheEsocial_styles_badgeSim__xqeUi,
.detalheEsocial_styles_badgeNao__RgqxK {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.detalheEsocial_styles_badgeSim__xqeUi {
  background: #e8f5e9;
  color: #2e7d32;
}

.detalheEsocial_styles_badgeNao__RgqxK {
  background: #fbe9e7;
  color: #c62828;
}

.detalheEsocial_styles_empty__GxU52 {
  text-align: center;
  padding: 24px;
  color: #888;
}

/* Filtro Base legal (multi-select) — mesmo padrão do Detalhe Conciliacao SPED. */
.detalheEsocial_styles_filtroMsDropdown__gdv6j {
  position: relative;
  min-width: 260px;
  max-width: 380px;
}

.detalheEsocial_styles_filtroMsTrigger__AjiDw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
  cursor: pointer;
  text-align: left;
  color: #333;
}

.detalheEsocial_styles_filtroMsTrigger__AjiDw:hover {
  border-color: #1e4a7a;
}

.detalheEsocial_styles_filtroMsTriggerText__Z\\+DZ8 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.detalheEsocial_styles_filtroMsChevron__e2Jo3 {
  font-size: 10px;
  color: #1e4a7a;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}

.detalheEsocial_styles_filtroMsChevronOpen__0zW7Y {
  transform: rotate(180deg);
}

.detalheEsocial_styles_filtroMsPanel__8t1Ru {
  position: absolute;
  z-index: 20;
  top: calc(100% + 4px);
  left: 0;
  min-width: 360px;
  width: max(100%, 360px);
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 10px;
}

.detalheEsocial_styles_filtroMsSearch__vDLKW {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  margin-bottom: 8px;
}

.detalheEsocial_styles_filtroMsActions__SYBWu {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px 10px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.detalheEsocial_styles_filtroMsActionBtn__wyPKG {
  padding: 4px 2px;
  border: none;
  background: none;
  color: #1e4a7a;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  line-height: 1.2;
}

.detalheEsocial_styles_filtroMsActionBtn__wyPKG:hover:not(:disabled) {
  text-decoration: underline;
}

.detalheEsocial_styles_filtroMsActionBtn__wyPKG:disabled {
  color: #9aa8c3;
  cursor: not-allowed;
  text-decoration: none;
}

.detalheEsocial_styles_filtroMsList__jnPur {
  max-height: 220px;
  overflow-y: auto;
}

.detalheEsocial_styles_filtroMsOption__34Zny {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 4px;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  border-radius: 4px;
}

.detalheEsocial_styles_filtroMsOption__34Zny:hover {
  background: #f5f7fa;
}

.detalheEsocial_styles_filtroMsOption__34Zny input {
  margin-top: 2px;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #1e4a7a;
}

.detalheEsocial_styles_filtroMsOptionLabel__upW6N {
  line-height: 1.35;
  word-break: break-word;
  min-width: 0;
}

.detalheEsocial_styles_filtroMsEmpty__mvOBG {
  margin: 0;
  padding: 8px 4px;
  font-size: 13px;
  color: #888;
  text-align: center;
}

.detalheEsocial_styles_paginationBar__PaZxi {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  padding: 14px 0 0;
  border-top: 1px solid #eee;
  font-size: 14px;
  color: #555;
}

.detalheEsocial_styles_paginationInfo__OjKCR {
  font-size: 14px;
  color: #555;
}

.detalheEsocial_styles_paginationControls__Tm3tR {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.detalheEsocial_styles_pgSizeGroup__gJdOa {
  display: flex;
  align-items: center;
  gap: 8px;
}

.detalheEsocial_styles_pgSizeLabel__00I0b {
  margin: 0;
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.detalheEsocial_styles_pageSizeSelect__7zAoN {
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  min-width: 72px;
  background: #fff;
  font-family: inherit;
}

.detalheEsocial_styles_btnPage__9eFHG {
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid #cfd8dc;
  background: #fff;
  color: #0d2847;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.detalheEsocial_styles_btnPage__9eFHG:hover:not(:disabled) {
  background: #f5f5f5;
}

.detalheEsocial_styles_btnPage__9eFHG:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.detalheEsocial_styles_btnMini__roVnR {
  padding: 8px 14px;
  border-radius: 6px;
  border: none;
  background: #1e4a7a;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.detalheEsocial_styles_btnMini__roVnR:hover {
  filter: brightness(1.06);
}

.detalheEsocial_styles_loading__zOM8g,
.detalheEsocial_styles_errorBox__nI\\+gl {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40vh;
  padding: 24px;
}

.detalheEsocial_styles_secondaryToolbar__BUkNv {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 12px;
}

.detalheEsocial_styles_lancamentosSubtitle__5XI-r {
  overflow-wrap: normal;
  word-break: normal;
}

.detalheEsocial_styles_lancamentosToolbar__pmuhZ {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.detalheEsocial_styles_lancamentosTableWrap__YzpdS {
  overflow-x: auto;
  scrollbar-width: auto;
}

.detalheEsocial_styles_lancamentosTable__bopeM {
  min-width: 1680px;
  width: max-content;
}

.detalheEsocial_styles_lancamentosTable__bopeM th,
.detalheEsocial_styles_lancamentosTable__bopeM td {
  padding: 10px 12px;
  white-space: nowrap;
  vertical-align: middle;
}

.detalheEsocial_styles_lancamentosTable__bopeM th {
  font-size: 12px;
}

.detalheEsocial_styles_lancamentosTable__bopeM td {
  font-size: 13px;
}

/* TXM-671 — grupos de colunas da aba Rúbricas (INSS / FGTS / IRRF) */
.detalheEsocial_styles_gruposBar__hkZVL {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 12px 0;
}

.detalheEsocial_styles_gruposBarTitulo__xeoci {
  font-size: 13px;
  font-weight: 600;
  color: #0d2847;
}

.detalheEsocial_styles_grupoChip__KZ\\+NU {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid transparent;
  -webkit-user-select: none;
          user-select: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.detalheEsocial_styles_grupoChip__KZ\\+NU input[type="checkbox"]:disabled {
  cursor: not-allowed;
}

/* Cores dos grupos: iguais ao protótipo (apuracao_inss_rubricas.html). */
.detalheEsocial_styles_grupoCor_fgts__pIILq { background: #e8f5e9; color: #2e7d32; border-color: #c8e6c9; }
.detalheEsocial_styles_grupoCor_irrf__F3frW { background: #fff3e0; color: #e65100; border-color: #ffe0b2; }
.detalheEsocial_styles_grupoCor_inss__GeH-h { background: #e3f2fd; color: #1565c0; border-color: #bbdefb; cursor: default; }

.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thGrupo__wxXHJ {
  text-align: center;
  font-size: 12px;
  letter-spacing: 0.4px;
  border-bottom: 1px solid #fff;
  border-left: 2px solid #fff;
  border-right: 2px solid #fff;
}
.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thGrupo_fgts__JursH { background: #e8f5e9; color: #2e7d32; }
.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thGrupo_irrf__cBW-t { background: #fff3e0; color: #e65100; }
.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thGrupo_inss__JTzaK { background: #e3f2fd; color: #1565c0; }

.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thSubGrupo__rHawd { font-size: 12px; }
.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thSubGrupo_fgts__0Cggk { background: #f4faf4; }
.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thSubGrupo_irrf__WdxUn { background: #fff9f0; }
.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thSubGrupo_inss__e931K { background: #f2f8fe; }

.detalheEsocial_styles_rubricasTable__3YyAS td.detalheEsocial_styles_celGrupo_fgts__NyNnH { background: #fafdfa; }
.detalheEsocial_styles_rubricasTable__3YyAS td.detalheEsocial_styles_celGrupo_irrf__iT-oF { background: #fffcf8; }
.detalheEsocial_styles_rubricasTable__3YyAS td.detalheEsocial_styles_celGrupo_inss__WGjp3 { background: #fafcff; }

/* divisória na 1ª coluna de cada grupo (cabeçalho e corpo) */
.detalheEsocial_styles_rubricasTable__3YyAS th.detalheEsocial_styles_thSubGrupoPrimeira__DGmtE,
.detalheEsocial_styles_rubricasTable__3YyAS td.detalheEsocial_styles_celGrupoPrimeira__7YrX4 { border-left: 2px solid #e0e6ec; }

.detalheEsocial_styles_rubricasToolbar__cDlJB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

/* TXM-671 — coluna "Período de vigência": régua de meses (início em cima, fim embaixo) */
.detalheEsocial_styles_rubricasTable__3YyAS td.detalheEsocial_styles_vigenciaCell__eHEU4 {
  min-width: 290px;
  white-space: normal;
  vertical-align: middle;
  padding-block: 6px;
}

.detalheEsocial_styles_regua__BQf0b {
  position: relative;
}

.detalheEsocial_styles_reguaFaixa__B-2\\+3 {
  position: relative;
}

.detalheEsocial_styles_reguaMeses__mFFkr {
  display: grid;
  height: 9px;
}

.detalheEsocial_styles_reguaMeses__mFFkr > span {
  box-sizing: border-box;
  border-right: 1px solid #fff;
  background: #e6eaf0;
}

.detalheEsocial_styles_reguaMeses__mFFkr > span.detalheEsocial_styles_mesAberto__IA4ZM {
  background: #1b7f4c;
}

.detalheEsocial_styles_reguaMeses__mFFkr > span.detalheEsocial_styles_mesFechado__rPGrJ {
  background: #1f5fbf;
}

.detalheEsocial_styles_reguaMarco__BW-WP {
  position: absolute;
  width: 8px;
  font-size: 12px;
  line-height: 14px;
  font-style: normal;
  text-align: center;
}

.detalheEsocial_styles_marco_inicio__LLW9J {
  color: #1f5fbf;
}

.detalheEsocial_styles_marco_fim__dQlQK {
  color: #c2410c;
}

.detalheEsocial_styles_marco_atual__GtToP {
  color: #1b7f4c;
}

.detalheEsocial_styles_reguaTraco__j4hG7 {
  position: absolute;
  width: 1px;
  background: #c3ccd8;
}

.detalheEsocial_styles_reguaRotulo__xpvt- {
  position: absolute;
  font-family: ui-monospace, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
  white-space: nowrap;
}

.detalheEsocial_styles_reguaAnos__VSdTy {
  display: flex;
  margin-top: 4px;
  font-size: 10px;
  font-weight: 400;
}

.detalheEsocial_styles_reguaAnos__VSdTy > span {
  box-sizing: border-box;
  border-left: 1px solid #c3ccd8;
  padding-left: 2px;
  text-align: left;
}

.detalheEsocial_styles_vigenciaLegenda__Oy3MF {
  margin: 4px 0 8px;
  font-size: 12px;
  color: #5b6b80;
}

.detalheEsocial_styles_legendaAberta__LKPcC,
.detalheEsocial_styles_legendaFechada__Mm3vC {
  margin-left: 12px;
}

.detalheEsocial_styles_legendaAberta__LKPcC::before,
.detalheEsocial_styles_legendaFechada__Mm3vC::before {
  content: "";
  display: inline-block;
  width: 9px;
  height: 9px;
  margin-right: 4px;
}

.detalheEsocial_styles_legendaAberta__LKPcC::before {
  background: #1b7f4c;
}

.detalheEsocial_styles_legendaFechada__Mm3vC::before {
  background: #1f5fbf;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Apuracoes/DetalheEsocial/detalheEsocial.styles.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,yFAAyF;AACzF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB,EAAE,yCAAyC;AAClE;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iBAEiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE,8CAAiB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC7E,8CAAiB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC7E,8CAAiB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE,eAAe,EAAE;;AAE9F;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA,2FAAiC,mBAAmB,EAAE,cAAc,EAAE;AACtE,2FAAiC,mBAAmB,EAAE,cAAc,EAAE;AACtE,2FAAiC,mBAAmB,EAAE,cAAc,EAAE;;AAEtE,yFAA+B,eAAe,EAAE;AAChD,8FAAoC,mBAAmB,EAAE;AACzD,8FAAoC,mBAAmB,EAAE;AACzD,8FAAoC,mBAAmB,EAAE;;AAEzD,4FAAkC,mBAAmB,EAAE;AACvD,4FAAkC,mBAAmB,EAAE;AACvD,4FAAkC,mBAAmB,EAAE;;AAEvD,6DAA6D;AAC7D;+FACqC,8BAA8B,EAAE;;AAErE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA,yFAAyF;AACzF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/**\n * Detalhe eSocial (TXM-336) — layout alinhado ao Detalhe Conciliacao SPED.\n */\n\n.pageWrap {\n  padding: 24px;\n}\n\n.container {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n}\n\n.linkVoltar {\n  display: inline-block;\n  margin-bottom: 12px;\n  font-size: 14px;\n  color: #1e4a7a;\n  font-weight: 600;\n  text-decoration: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n}\n\n.linkVoltar:hover {\n  text-decoration: underline;\n}\n\n.pageHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: nowrap;\n  margin-bottom: 25px;\n}\n\n.headerMain {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.pageTitle {\n  font-size: 26px;\n  color: #0d2847;\n  font-weight: 600;\n  line-height: 1.25;\n  margin: 0;\n}\n\n.pageSubtitle {\n  font-size: 14px;\n  color: #666;\n  margin-top: 8px;\n  font-family: ui-monospace, monospace;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n\n.contaRef {\n  display: inline-block;\n  margin-top: 4px;\n  color: #1e4a7a;\n  font-weight: 600;\n}\n\n.badgeTipo {\n  display: inline-block;\n  margin-top: 10px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #e8f0f8;\n  color: #1e4a7a;\n}\n\n.badgeRubricas {\n  display: inline-block;\n  margin-top: 10px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.badge20s {\n  display: inline-block;\n  margin-top: 10px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #f3e5f5;\n  color: #6a1b9a;\n}\n\n.headerActions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  max-width: min(520px, 48%);\n}\n\n@media (max-width: 900px) {\n  .pageHeader {\n    flex-wrap: wrap;\n  }\n\n  .headerActions {\n    max-width: 100%;\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n.btnHeader {\n  padding: 10px 16px;\n  border-radius: 6px;\n  border: 1px solid #1e4a7a;\n  background: #fff;\n  color: #1e4a7a;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnHeaderPrimary {\n  background: #1e4a7a;\n  color: #fff;\n  border-color: #1e4a7a;\n}\n\n.btnHeaderActive {\n  background: #e8f0f8;\n  border-color: #1e4a7a;\n}\n\n.btnHeader:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n\n.btnHeader:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.dashWrap {\n  margin-bottom: 25px;\n}\n\n.dashGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px 18px;\n}\n\n@media (max-width: 1100px) {\n  .dashGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .dashGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dashCard {\n  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);\n  border-radius: 12px;\n  padding: 16px 14px;\n  border-left: 4px solid #1e4a7a;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  min-width: 0;\n}\n\n.dashCardVazio {\n  grid-column: 1 / -1;\n  border-left-color: #888;\n  background: linear-gradient(135deg, #f5f5f5 0%, #fff 100%);\n}\n\n.dashCardWide {\n  grid-column: 1 / -1;\n  max-width: 420px;\n}\n\n.dashAlertaTexto {\n  margin: 10px 0 0;\n  font-size: 13px;\n  color: #555;\n  line-height: 1.5;\n}\n\n.dashLbl {\n  font-size: 12px;\n  color: #666;\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n.dashHint {\n  font-size: 11px;\n  color: #888;\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n.dashVal {\n  margin-top: 8px;\n  font-weight: 700;\n  color: #0d2847;\n  font-family: ui-monospace, monospace;\n  font-size: clamp(12px, 0.2rem + 1.15vw, 15px);\n}\n\n.dashStack {\n  display: flex;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n  margin-top: 12px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.dashStack span {\n  display: block;\n  min-width: 0;\n}\n\n.dashLegend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  margin-top: 10px;\n  font-size: 11px;\n  color: #555;\n}\n\n.dashLegend strong {\n  color: #0d2847;\n  font-weight: 700;\n}\n\n.dashLegendPct {\n  color: #888;\n}\n\n.yearDot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  margin-right: 5px;\n  vertical-align: middle;\n}\n\n/* Seta de expandir/recolher a legenda dos cards de dashboard quando passa de 3 linhas. */\n.dashLegendToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  padding: 2px 0;\n  border: none;\n  background: none;\n  color: #1f5fa8;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dashLegendToggle:hover {\n  text-decoration: underline;\n}\n\n.dashLegendToggleIcon {\n  display: inline-block;\n  font-size: 10px;\n  transition: transform 0.15s ease;\n}\n\n.dashLegendToggleIconOpen {\n  transform: rotate(180deg);\n}\n\n.sectionListHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0d2847;\n  margin: 0;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-left: auto;\n}\n\n.toolbarHint {\n  font-size: 13px;\n  color: #666;\n}\n\n.btnExportar {\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: 1px solid #1e4a7a;\n  background: #fff;\n  color: #1e4a7a;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnExportar:hover:not(:disabled) {\n  background: #f0f4fa;\n}\n\n.btnExportar:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.exportMenuWrap {\n  position: relative;\n}\n\n.exportMenu {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  margin-top: 4px;\n  z-index: 20;\n  min-width: 200px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 4px 0;\n}\n\n.exportMenuItem {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  font: inherit;\n  font-size: 13px;\n  color: #0d2847;\n  cursor: pointer;\n}\n\n.exportMenuItem:hover {\n  background: #f0f2f5;\n}\n\n.filtersSection {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px 20px 20px;\n  margin-bottom: 25px;\n}\n\n.filtersSectionCollapsed {\n  padding-bottom: 16px;\n}\n\n.filtersHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n}\n\n.filtersHeaderExpanded {\n  margin-bottom: 12px;\n}\n\n.filtersTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0d2847;\n  margin-bottom: 0;\n}\n\n.filtersToggleIcon {\n  font-size: 11px;\n  color: #1e4a7a;\n  transition: transform 0.2s ease;\n  transform: rotate(-90deg);\n  line-height: 1;\n}\n\n.filtersToggleIconOpen {\n  transform: rotate(0deg);\n}\n\n.filtersBody {\n  padding-top: 4px;\n}\n\n.filtersRow {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n  align-items: flex-end;\n}\n\n.filterGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filterLabel {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n.filterInput,\n.filterSelect {\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  min-width: 160px;\n  font-family: inherit;\n  background: #fff;\n}\n\n.filterInput[type=\"month\"] {\n  min-height: 38px;\n}\n\n.filterTwin {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filterTwinSep {\n  font-size: 12px;\n  color: #888;\n}\n\n.btnLimpar {\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  background: #fff;\n  color: #555;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.tableWrap {\n  width: 100%;\n  overflow-x: auto;\n  margin-bottom: 16px;\n  scrollbar-width: auto; /* Firefox — evita barra fina do global */\n}\n\n.tableWrap::-webkit-scrollbar,\n.lancamentosTableWrap::-webkit-scrollbar {\n  height: 12px;\n  width: 12px;\n}\n\n.tableWrap::-webkit-scrollbar-track,\n.lancamentosTableWrap::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 6px;\n}\n\n.tableWrap::-webkit-scrollbar-thumb,\n.lancamentosTableWrap::-webkit-scrollbar-thumb {\n  background: rgba(24, 49, 110, 0.75);\n  border-radius: 6px;\n}\n\n.tableWrap::-webkit-scrollbar-thumb:hover,\n.lancamentosTableWrap::-webkit-scrollbar-thumb:hover {\n  background: rgba(24, 49, 110, 0.95);\n}\n\n.table {\n  width: 100%;\n  min-width: 2480px;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.table thead {\n  background: #f8f9fa;\n}\n\n.table th {\n  padding: 15px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #0d2847;\n  border-bottom: 2px solid #e0e0e0;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.table th.num,\n.table td.num,\n.num {\n  text-align: right;\n}\n\n/* Colunas monetárias: largura acompanha header/valor sem quebrar linha */\n.colValor {\n  white-space: nowrap;\n  min-width: 158px;\n  width: 1%;\n  padding-left: 14px;\n  padding-right: 16px;\n  box-sizing: border-box;\n}\n\n.table th.colValor,\n.table td.colValor {\n  white-space: nowrap;\n  min-width: 158px;\n  width: 1%;\n  padding-left: 14px;\n  padding-right: 16px;\n}\n\n.sortable {\n  cursor: pointer;\n  user-select: none;\n  padding-right: 22px;\n  position: relative;\n}\n\n.table th.sortable:hover {\n  background: #eef2f7;\n}\n\n.sortedAsc::after,\n.sortedDesc::after {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 10px;\n  color: #1e4a7a;\n}\n\n.sortedAsc::after {\n  content: \"▲\";\n}\n\n.sortedDesc::after {\n  content: \"▼\";\n}\n\n.table td {\n  padding: 15px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 14px;\n  color: #555;\n  vertical-align: middle;\n}\n\n.table td.num {\n  font-family: ui-monospace, monospace;\n  white-space: nowrap;\n}\n\n.table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.rowCompStart td {\n  border-top: 2px solid #e0e8ef;\n}\n\n.rowCompStart:first-child td {\n  border-top: none;\n}\n\n/* TXM-480 — destaque de linhas cuja rubrica tem base legal atribuída (fazem parte do\n   projeto de recuperação). Compartilhado pelas tabelas de Detalhe, Rúbricas e\n   Lançamentos. */\n.linhaComBaseLegal td {\n  background: #eef4ff;\n}\n\n.table tbody tr.linhaComBaseLegal:hover td {\n  background: #e2ecff;\n}\n\n.badgeBaseLegal {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #dbeafe;\n  color: #1e3a8a;\n  white-space: nowrap;\n}\n\n.compCell {\n  font-weight: 600;\n  color: #0d2847;\n  white-space: nowrap;\n}\n\n.rubricaCod {\n  font-family: ui-monospace, monospace;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.rubricaDesc {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rubricasTable {\n  min-width: 1580px;\n}\n\n.rubricasTable th {\n  white-space: nowrap;\n  vertical-align: bottom;\n}\n\n.rubricasTable td {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rubricasTable td.cellFlag {\n  max-width: none;\n  overflow: visible;\n  white-space: nowrap;\n  padding: 6px 10px;\n  text-align: left;\n}\n\n.badgeSim,\n.badgeNao {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.badgeSim {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.badgeNao {\n  background: #fbe9e7;\n  color: #c62828;\n}\n\n.empty {\n  text-align: center;\n  padding: 24px;\n  color: #888;\n}\n\n/* Filtro Base legal (multi-select) — mesmo padrão do Detalhe Conciliacao SPED. */\n.filtroMsDropdown {\n  position: relative;\n  min-width: 260px;\n  max-width: 380px;\n}\n\n.filtroMsTrigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  color: #333;\n}\n\n.filtroMsTrigger:hover {\n  border-color: #1e4a7a;\n}\n\n.filtroMsTriggerText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.filtroMsChevron {\n  font-size: 10px;\n  color: #1e4a7a;\n  transition: transform 0.15s ease;\n  flex-shrink: 0;\n}\n\n.filtroMsChevronOpen {\n  transform: rotate(180deg);\n}\n\n.filtroMsPanel {\n  position: absolute;\n  z-index: 20;\n  top: calc(100% + 4px);\n  left: 0;\n  min-width: 360px;\n  width: max(100%, 360px);\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  padding: 10px;\n}\n\n.filtroMsSearch {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: inherit;\n  margin-bottom: 8px;\n}\n\n.filtroMsActions {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 4px 10px;\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n.filtroMsActionBtn {\n  padding: 4px 2px;\n  border: none;\n  background: none;\n  color: #1e4a7a;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  line-height: 1.2;\n}\n\n.filtroMsActionBtn:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.filtroMsActionBtn:disabled {\n  color: #9aa8c3;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.filtroMsList {\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.filtroMsOption {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 6px 4px;\n  font-size: 13px;\n  color: #444;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.filtroMsOption:hover {\n  background: #f5f7fa;\n}\n\n.filtroMsOption input {\n  margin-top: 2px;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #1e4a7a;\n}\n\n.filtroMsOptionLabel {\n  line-height: 1.35;\n  word-break: break-word;\n  min-width: 0;\n}\n\n.filtroMsEmpty {\n  margin: 0;\n  padding: 8px 4px;\n  font-size: 13px;\n  color: #888;\n  text-align: center;\n}\n\n.paginationBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px;\n  padding: 14px 0 0;\n  border-top: 1px solid #eee;\n  font-size: 14px;\n  color: #555;\n}\n\n.paginationInfo {\n  font-size: 14px;\n  color: #555;\n}\n\n.paginationControls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.pgSizeGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pgSizeLabel {\n  margin: 0;\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n.pageSizeSelect {\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  min-width: 72px;\n  background: #fff;\n  font-family: inherit;\n}\n\n.btnPage {\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: 1px solid #cfd8dc;\n  background: #fff;\n  color: #0d2847;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnPage:hover:not(:disabled) {\n  background: #f5f5f5;\n}\n\n.btnPage:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.btnMini {\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: none;\n  background: #1e4a7a;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnMini:hover {\n  filter: brightness(1.06);\n}\n\n.loading,\n.errorBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 40vh;\n  padding: 24px;\n}\n\n.secondaryToolbar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.lancamentosSubtitle {\n  overflow-wrap: normal;\n  word-break: normal;\n}\n\n.lancamentosToolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.lancamentosTableWrap {\n  overflow-x: auto;\n  scrollbar-width: auto;\n}\n\n.lancamentosTable {\n  min-width: 1680px;\n  width: max-content;\n}\n\n.lancamentosTable th,\n.lancamentosTable td {\n  padding: 10px 12px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.lancamentosTable th {\n  font-size: 12px;\n}\n\n.lancamentosTable td {\n  font-size: 13px;\n}\n\n/* TXM-671 — grupos de colunas da aba Rúbricas (INSS / FGTS / IRRF) */\n.gruposBar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 12px 0;\n}\n\n.gruposBarTitulo {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0d2847;\n}\n\n.grupoChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border-radius: 20px;\n  border: 1px solid transparent;\n  user-select: none;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.grupoChip input[type=\"checkbox\"]:disabled {\n  cursor: not-allowed;\n}\n\n/* Cores dos grupos: iguais ao protótipo (apuracao_inss_rubricas.html). */\n.grupoCor_fgts { background: #e8f5e9; color: #2e7d32; border-color: #c8e6c9; }\n.grupoCor_irrf { background: #fff3e0; color: #e65100; border-color: #ffe0b2; }\n.grupoCor_inss { background: #e3f2fd; color: #1565c0; border-color: #bbdefb; cursor: default; }\n\n.rubricasTable th.thGrupo {\n  text-align: center;\n  font-size: 12px;\n  letter-spacing: 0.4px;\n  border-bottom: 1px solid #fff;\n  border-left: 2px solid #fff;\n  border-right: 2px solid #fff;\n}\n.rubricasTable th.thGrupo_fgts { background: #e8f5e9; color: #2e7d32; }\n.rubricasTable th.thGrupo_irrf { background: #fff3e0; color: #e65100; }\n.rubricasTable th.thGrupo_inss { background: #e3f2fd; color: #1565c0; }\n\n.rubricasTable th.thSubGrupo { font-size: 12px; }\n.rubricasTable th.thSubGrupo_fgts { background: #f4faf4; }\n.rubricasTable th.thSubGrupo_irrf { background: #fff9f0; }\n.rubricasTable th.thSubGrupo_inss { background: #f2f8fe; }\n\n.rubricasTable td.celGrupo_fgts { background: #fafdfa; }\n.rubricasTable td.celGrupo_irrf { background: #fffcf8; }\n.rubricasTable td.celGrupo_inss { background: #fafcff; }\n\n/* divisória na 1ª coluna de cada grupo (cabeçalho e corpo) */\n.rubricasTable th.thSubGrupoPrimeira,\n.rubricasTable td.celGrupoPrimeira { border-left: 2px solid #e0e6ec; }\n\n.rubricasToolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n/* TXM-671 — coluna \"Período de vigência\": régua de meses (início em cima, fim embaixo) */\n.rubricasTable td.vigenciaCell {\n  min-width: 290px;\n  white-space: normal;\n  vertical-align: middle;\n  padding-block: 6px;\n}\n\n.regua {\n  position: relative;\n}\n\n.reguaFaixa {\n  position: relative;\n}\n\n.reguaMeses {\n  display: grid;\n  height: 9px;\n}\n\n.reguaMeses > span {\n  box-sizing: border-box;\n  border-right: 1px solid #fff;\n  background: #e6eaf0;\n}\n\n.reguaMeses > span.mesAberto {\n  background: #1b7f4c;\n}\n\n.reguaMeses > span.mesFechado {\n  background: #1f5fbf;\n}\n\n.reguaMarco {\n  position: absolute;\n  width: 8px;\n  font-size: 12px;\n  line-height: 14px;\n  font-style: normal;\n  text-align: center;\n}\n\n.marco_inicio {\n  color: #1f5fbf;\n}\n\n.marco_fim {\n  color: #c2410c;\n}\n\n.marco_atual {\n  color: #1b7f4c;\n}\n\n.reguaTraco {\n  position: absolute;\n  width: 1px;\n  background: #c3ccd8;\n}\n\n.reguaRotulo {\n  position: absolute;\n  font-family: ui-monospace, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 14px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.reguaAnos {\n  display: flex;\n  margin-top: 4px;\n  font-size: 10px;\n  font-weight: 400;\n}\n\n.reguaAnos > span {\n  box-sizing: border-box;\n  border-left: 1px solid #c3ccd8;\n  padding-left: 2px;\n  text-align: left;\n}\n\n.vigenciaLegenda {\n  margin: 4px 0 8px;\n  font-size: 12px;\n  color: #5b6b80;\n}\n\n.legendaAberta,\n.legendaFechada {\n  margin-left: 12px;\n}\n\n.legendaAberta::before,\n.legendaFechada::before {\n  content: \"\";\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  margin-right: 4px;\n}\n\n.legendaAberta::before {\n  background: #1b7f4c;\n}\n\n.legendaFechada::before {\n  background: #1f5fbf;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `detalheEsocial_styles_pageWrap__IoePv`,
	"container": `detalheEsocial_styles_container__mrVzS`,
	"linkVoltar": `detalheEsocial_styles_linkVoltar__R0mjr`,
	"pageHeader": `detalheEsocial_styles_pageHeader__evHr-`,
	"headerMain": `detalheEsocial_styles_headerMain__hO6xL`,
	"pageTitle": `detalheEsocial_styles_pageTitle__lDPbL`,
	"pageSubtitle": `detalheEsocial_styles_pageSubtitle__Czle2`,
	"contaRef": `detalheEsocial_styles_contaRef__DYgST`,
	"badgeTipo": `detalheEsocial_styles_badgeTipo__L8hGe`,
	"badgeRubricas": `detalheEsocial_styles_badgeRubricas__jSZ8S`,
	"badge20s": `detalheEsocial_styles_badge20s__U92tS`,
	"headerActions": `detalheEsocial_styles_headerActions__XHsf3`,
	"btnHeader": `detalheEsocial_styles_btnHeader__wk-j5`,
	"btnHeaderPrimary": `detalheEsocial_styles_btnHeaderPrimary__46Bjd`,
	"btnHeaderActive": `detalheEsocial_styles_btnHeaderActive__7Omfn`,
	"dashWrap": `detalheEsocial_styles_dashWrap__tHWaH`,
	"dashGrid": `detalheEsocial_styles_dashGrid__-4wfm`,
	"dashCard": `detalheEsocial_styles_dashCard__+sf0t`,
	"dashCardVazio": `detalheEsocial_styles_dashCardVazio__UXYAu`,
	"dashCardWide": `detalheEsocial_styles_dashCardWide__NKoX-`,
	"dashAlertaTexto": `detalheEsocial_styles_dashAlertaTexto__VwuLN`,
	"dashLbl": `detalheEsocial_styles_dashLbl__5Sq1b`,
	"dashHint": `detalheEsocial_styles_dashHint__Qtp5N`,
	"dashVal": `detalheEsocial_styles_dashVal__vOSOE`,
	"dashStack": `detalheEsocial_styles_dashStack__1CQeC`,
	"dashLegend": `detalheEsocial_styles_dashLegend__PQR-4`,
	"dashLegendPct": `detalheEsocial_styles_dashLegendPct__bfeot`,
	"yearDot": `detalheEsocial_styles_yearDot__i6WGn`,
	"dashLegendToggle": `detalheEsocial_styles_dashLegendToggle__V6v6J`,
	"dashLegendToggleIcon": `detalheEsocial_styles_dashLegendToggleIcon__q0bOa`,
	"dashLegendToggleIconOpen": `detalheEsocial_styles_dashLegendToggleIconOpen__f8YWD`,
	"sectionListHeader": `detalheEsocial_styles_sectionListHeader__wq6ld`,
	"sectionTitle": `detalheEsocial_styles_sectionTitle__JQIuW`,
	"toolbar": `detalheEsocial_styles_toolbar__1cl28`,
	"toolbarHint": `detalheEsocial_styles_toolbarHint__ErtiT`,
	"btnExportar": `detalheEsocial_styles_btnExportar__lwo1a`,
	"exportMenuWrap": `detalheEsocial_styles_exportMenuWrap__pGNVy`,
	"exportMenu": `detalheEsocial_styles_exportMenu__9B3oP`,
	"exportMenuItem": `detalheEsocial_styles_exportMenuItem__TM6Ei`,
	"filtersSection": `detalheEsocial_styles_filtersSection__wi2iZ`,
	"filtersSectionCollapsed": `detalheEsocial_styles_filtersSectionCollapsed__51TuN`,
	"filtersHeader": `detalheEsocial_styles_filtersHeader__iqXDm`,
	"filtersHeaderExpanded": `detalheEsocial_styles_filtersHeaderExpanded__CzLfg`,
	"filtersTitle": `detalheEsocial_styles_filtersTitle__A+4vZ`,
	"filtersToggleIcon": `detalheEsocial_styles_filtersToggleIcon__noJm+`,
	"filtersToggleIconOpen": `detalheEsocial_styles_filtersToggleIconOpen__rr4Bb`,
	"filtersBody": `detalheEsocial_styles_filtersBody__OZo2I`,
	"filtersRow": `detalheEsocial_styles_filtersRow__hWHdf`,
	"filterGroup": `detalheEsocial_styles_filterGroup__sqnZi`,
	"filterLabel": `detalheEsocial_styles_filterLabel__t9KPr`,
	"filterInput": `detalheEsocial_styles_filterInput__tUVrS`,
	"filterSelect": `detalheEsocial_styles_filterSelect__WpI5F`,
	"filterTwin": `detalheEsocial_styles_filterTwin__YBcY3`,
	"filterTwinSep": `detalheEsocial_styles_filterTwinSep__A-Z6j`,
	"btnLimpar": `detalheEsocial_styles_btnLimpar__27pyD`,
	"tableWrap": `detalheEsocial_styles_tableWrap__jkTBo`,
	"lancamentosTableWrap": `detalheEsocial_styles_lancamentosTableWrap__YzpdS`,
	"table": `detalheEsocial_styles_table__WlcTn`,
	"num": `detalheEsocial_styles_num__1FRM3`,
	"colValor": `detalheEsocial_styles_colValor__gGg+9`,
	"sortable": `detalheEsocial_styles_sortable__9am1O`,
	"sortedAsc": `detalheEsocial_styles_sortedAsc__ahxWE`,
	"sortedDesc": `detalheEsocial_styles_sortedDesc__h-OHL`,
	"rowCompStart": `detalheEsocial_styles_rowCompStart__JP42o`,
	"linhaComBaseLegal": `detalheEsocial_styles_linhaComBaseLegal__dg0cv`,
	"badgeBaseLegal": `detalheEsocial_styles_badgeBaseLegal__KByhD`,
	"compCell": `detalheEsocial_styles_compCell__4X2qS`,
	"rubricaCod": `detalheEsocial_styles_rubricaCod__ALqaF`,
	"rubricaDesc": `detalheEsocial_styles_rubricaDesc__ishja`,
	"rubricasTable": `detalheEsocial_styles_rubricasTable__3YyAS`,
	"cellFlag": `detalheEsocial_styles_cellFlag__3rYnR`,
	"badgeSim": `detalheEsocial_styles_badgeSim__xqeUi`,
	"badgeNao": `detalheEsocial_styles_badgeNao__RgqxK`,
	"empty": `detalheEsocial_styles_empty__GxU52`,
	"filtroMsDropdown": `detalheEsocial_styles_filtroMsDropdown__gdv6j`,
	"filtroMsTrigger": `detalheEsocial_styles_filtroMsTrigger__AjiDw`,
	"filtroMsTriggerText": `detalheEsocial_styles_filtroMsTriggerText__Z+DZ8`,
	"filtroMsChevron": `detalheEsocial_styles_filtroMsChevron__e2Jo3`,
	"filtroMsChevronOpen": `detalheEsocial_styles_filtroMsChevronOpen__0zW7Y`,
	"filtroMsPanel": `detalheEsocial_styles_filtroMsPanel__8t1Ru`,
	"filtroMsSearch": `detalheEsocial_styles_filtroMsSearch__vDLKW`,
	"filtroMsActions": `detalheEsocial_styles_filtroMsActions__SYBWu`,
	"filtroMsActionBtn": `detalheEsocial_styles_filtroMsActionBtn__wyPKG`,
	"filtroMsList": `detalheEsocial_styles_filtroMsList__jnPur`,
	"filtroMsOption": `detalheEsocial_styles_filtroMsOption__34Zny`,
	"filtroMsOptionLabel": `detalheEsocial_styles_filtroMsOptionLabel__upW6N`,
	"filtroMsEmpty": `detalheEsocial_styles_filtroMsEmpty__mvOBG`,
	"paginationBar": `detalheEsocial_styles_paginationBar__PaZxi`,
	"paginationInfo": `detalheEsocial_styles_paginationInfo__OjKCR`,
	"paginationControls": `detalheEsocial_styles_paginationControls__Tm3tR`,
	"pgSizeGroup": `detalheEsocial_styles_pgSizeGroup__gJdOa`,
	"pgSizeLabel": `detalheEsocial_styles_pgSizeLabel__00I0b`,
	"pageSizeSelect": `detalheEsocial_styles_pageSizeSelect__7zAoN`,
	"btnPage": `detalheEsocial_styles_btnPage__9eFHG`,
	"btnMini": `detalheEsocial_styles_btnMini__roVnR`,
	"loading": `detalheEsocial_styles_loading__zOM8g`,
	"errorBox": `detalheEsocial_styles_errorBox__nI+gl`,
	"secondaryToolbar": `detalheEsocial_styles_secondaryToolbar__BUkNv`,
	"lancamentosSubtitle": `detalheEsocial_styles_lancamentosSubtitle__5XI-r`,
	"lancamentosToolbar": `detalheEsocial_styles_lancamentosToolbar__pmuhZ`,
	"lancamentosTable": `detalheEsocial_styles_lancamentosTable__bopeM`,
	"gruposBar": `detalheEsocial_styles_gruposBar__hkZVL`,
	"gruposBarTitulo": `detalheEsocial_styles_gruposBarTitulo__xeoci`,
	"grupoChip": `detalheEsocial_styles_grupoChip__KZ+NU`,
	"grupoCor_fgts": `detalheEsocial_styles_grupoCor_fgts__pIILq`,
	"grupoCor_irrf": `detalheEsocial_styles_grupoCor_irrf__F3frW`,
	"grupoCor_inss": `detalheEsocial_styles_grupoCor_inss__GeH-h`,
	"thGrupo": `detalheEsocial_styles_thGrupo__wxXHJ`,
	"thGrupo_fgts": `detalheEsocial_styles_thGrupo_fgts__JursH`,
	"thGrupo_irrf": `detalheEsocial_styles_thGrupo_irrf__cBW-t`,
	"thGrupo_inss": `detalheEsocial_styles_thGrupo_inss__JTzaK`,
	"thSubGrupo": `detalheEsocial_styles_thSubGrupo__rHawd`,
	"thSubGrupo_fgts": `detalheEsocial_styles_thSubGrupo_fgts__0Cggk`,
	"thSubGrupo_irrf": `detalheEsocial_styles_thSubGrupo_irrf__WdxUn`,
	"thSubGrupo_inss": `detalheEsocial_styles_thSubGrupo_inss__e931K`,
	"celGrupo_fgts": `detalheEsocial_styles_celGrupo_fgts__NyNnH`,
	"celGrupo_irrf": `detalheEsocial_styles_celGrupo_irrf__iT-oF`,
	"celGrupo_inss": `detalheEsocial_styles_celGrupo_inss__WGjp3`,
	"thSubGrupoPrimeira": `detalheEsocial_styles_thSubGrupoPrimeira__DGmtE`,
	"celGrupoPrimeira": `detalheEsocial_styles_celGrupoPrimeira__7YrX4`,
	"rubricasToolbar": `detalheEsocial_styles_rubricasToolbar__cDlJB`,
	"vigenciaCell": `detalheEsocial_styles_vigenciaCell__eHEU4`,
	"regua": `detalheEsocial_styles_regua__BQf0b`,
	"reguaFaixa": `detalheEsocial_styles_reguaFaixa__B-2+3`,
	"reguaMeses": `detalheEsocial_styles_reguaMeses__mFFkr`,
	"mesAberto": `detalheEsocial_styles_mesAberto__IA4ZM`,
	"mesFechado": `detalheEsocial_styles_mesFechado__rPGrJ`,
	"reguaMarco": `detalheEsocial_styles_reguaMarco__BW-WP`,
	"marco_inicio": `detalheEsocial_styles_marco_inicio__LLW9J`,
	"marco_fim": `detalheEsocial_styles_marco_fim__dQlQK`,
	"marco_atual": `detalheEsocial_styles_marco_atual__GtToP`,
	"reguaTraco": `detalheEsocial_styles_reguaTraco__j4hG7`,
	"reguaRotulo": `detalheEsocial_styles_reguaRotulo__xpvt-`,
	"reguaAnos": `detalheEsocial_styles_reguaAnos__VSdTy`,
	"vigenciaLegenda": `detalheEsocial_styles_vigenciaLegenda__Oy3MF`,
	"legendaAberta": `detalheEsocial_styles_legendaAberta__LKPcC`,
	"legendaFechada": `detalheEsocial_styles_legendaFechada__Mm3vC`
};
export default ___CSS_LOADER_EXPORT___;
